import "./NavBar.scss";
import cseLogo from "../assets/cse logo.webp";
import Button from "./Button";
import { FaBars } from "react-icons/fa";
import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

function useOutsideAlerter(ref, callback) {
	useEffect(() => {
		function handleClickOutside(event) {
			if (ref.current && !ref.current.contains(event.target)) {
				callback();
			}
		}
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [ref, callback]);
}

const NavBar = () => {
	const [navOpen, setNavOpen] = useState(false);
	const menu = useRef(null);
	const toggleNavOpen = () => {
		const val = navOpen ? false : true;
		setNavOpen(val);
	};
	const closeNav = () => {
		setNavOpen(false);
	};
	useOutsideAlerter(menu, closeNav);

	return (
		<nav className="nav" ref={menu}>
			<img src={cseLogo} alt="" />
			<span className="expand">
				<Button
					onClick={toggleNavOpen}
					reverseSkew={!navOpen}
					inverse={navOpen}
				>
					<FaBars />
				</Button>
			</span>
			<ul className={`${navOpen ? "expanded" : " "}`} onClick={closeNav}>
				<Button as={Link} href="/">
					Home
				</Button>
				<Button as={Link} href="/events">
					Details
				</Button>

				<Button
					as="a"
					href="https://vyvidh.vidyaacademy.ac.in/"
					target="_blank"
				>
					Vyvidh 22
				</Button>
				<Button
					href="https://vyvidh.vidyaacademy.ac.in/vcair.html"
					target="_blank"
				>
					AI ML Expo
				</Button>
			</ul>
		</nav>
	);
};

export default NavBar;
